import { BASE_URL } from "../api_const";


export const PROJECT_RIGHTS_BASE_URL = BASE_URL + "/services/project-rights"
export const ALL_PROJECT_RIGHTS = PROJECT_RIGHTS_BASE_URL + "/all"
export const PROJECT_RIGHTS_DETAILS_BY_ID = PROJECT_RIGHTS_BASE_URL 

